import React, { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import ListingComponent from '../../Components/Molecule/ListingComponent'
import CONSTANTS, { PAGES_ROUTES } from '../../Constants'
import {
  combineErrorMessage,
  commaSeparatedArrOfString,
  getListingRowData,
  handleResponse,
} from '../../Helpers/Util'
import {
  CLUSTER_CRUD,
  CONTAINER_MANAGEMENT_CRUD,
  COUNTRIES_CRUD,
  PLATFORM_CRUD,
} from '../../Constants/ApiDefinations'
import mainApiService from '../../Services'
import { useAppDispatch } from '../../Store/Hooks'
import { showAlert } from '../../Store/Slice/alert.slice'
import { getMasterByKey } from '../../Store/Slice/system-configuration.slice'
import { resetContainerData } from '../../Store/Slice/manage-container.slice'
import ContainerRightDrawer from '../../Components/ManageContainer/ContainerRightDrawer'
import { COMMON_LISTING_FILTERS, MANAGE_CONTAINER } from '../../Constants/Texts'
import { getLocalStorage } from '../../Helpers/Storage'
import updateTagMetaData from '../../Helpers/UpdateTagMetaData'
import { PageNames } from '../../Constants/PagesRoutes/PageURLs'
import TrayRankingStatusChip from '../../Components/Labels/TrayRankingStatusChip'
import { containerTrayRankingDefinitionKey } from '../../Helpers/constant'

interface ContainerListingProps {
  entryPoint?: string
}

const ContainerListing: React.FC<ContainerListingProps> = ({ entryPoint }) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [dataCount, setDataCount] = useState(0)
  const [listData, setListData] = useState<any[]>([])
  const [openDrawer, setOpenDrawer] = useState<boolean>(false)
  const [searchParams, setSearchParams] = useSearchParams()

  const [stateList, setStateList] = useState<{ key: string; value: string }[]>([])
  const [languageList, setLanguageList] = useState<{ key: string; value: string }[]>([])
  const [containerLayoutList, setContainerLayoutList] = useState<{ key: string; value: string }[]>(
    [],
  )
  const location = useLocation()

  const searchParameter = new URLSearchParams(location.search)?.get('state')
  const [paramState, setParamState] = useState<string | null>(null)
  const [isLoader, setIsLoader] = useState<boolean>(true)
  const [searchFunctionFilters, setSearchFunctionFilters] = useState<{
    sortBy: string | number
    filterValue: string
    sortType: number
    page: number
    limit: number
    filters: any
  }>({ sortBy: '', filterValue: '', sortType: 0, page: 1, limit: 10, filters: [] })
  const [columnValue, setColumnValue] = useState<any>([])
  const [columnData, setColumnData] = useState<any>([])
  const [countryList, setCountryList] = useState<any[]>([])
  const [clusterList, setClusterList] = useState<any[]>([])
  const [allPlatforms, setAllPlatforms] = useState<any[]>([])

  useEffect(() => {
    dispatch(resetContainerData(undefined))
    getFilterOptionsList()
    setParamState(searchParameter)
    setColumnValue(getLocalStorage('listing_column'))
  }, [])

  useEffect(() => {
    updateTagMetaData({ title: 'Manage Container' })
    return () => {
      updateTagMetaData({})
    }
  }, [])

  useEffect(() => {
    if (location?.search === '') {
      setParamState(null)
    }
  }, [location])

  useEffect(() => {
    if (Array.isArray(columnValue)) {
      const containerParameters =
        columnValue?.find((module: any) => module.module === 'container')?.parameters || []
      setColumnData(
        containerParameters.sort(
          (prevItem: any, nextItem: any) => prevItem.sequence - nextItem.sequence,
        ),
      )
    }
  }, [columnValue])

  const getFilterOptionsList = async () => {
    const result = await dispatch(getMasterByKey('keyName=STATES') as any)
    setStateList(result?.payload?.data)

    const result2 = await dispatch(getMasterByKey('keyName=LANGUAGE') as any)
    setLanguageList(result2?.payload?.data)

    const requestedData = CONTAINER_MANAGEMENT_CRUD.LAYOUT.LIST('')
    const result1: any = await mainApiService(requestedData)

    setContainerLayoutList(result1?.data?.Layouts)

    const countryData = COUNTRIES_CRUD.LIST_COUNTRY('sortBy=value&sortType=1')
    const countryResult: any = await mainApiService(countryData)
    if (countryResult?.responseCode === 200) {
      const tempData: any = []
      countryResult?.data?.records?.forEach((ele: any) => {
        tempData.push({
          key: ele?._id,
          value: ele?.value,
        })
      })
      setCountryList(tempData)
    }
    const clusterResult: any = await mainApiService(CLUSTER_CRUD.LIST_CLUSTER(''))
    if (clusterResult?.responseCode === 200) {
      const tempData: any = []
      clusterResult?.data?.records?.forEach((ele: any) => {
        tempData.push({
          key: ele?._id,
          value: ele?.value,
        })
      })
      setClusterList(tempData)
    }
    const platformResult: any = await mainApiService(PLATFORM_CRUD.LIST_PLATFORM(''))
    if (platformResult?.responseCode === 200) {
      const tempData: any = []
      platformResult?.data?.records?.forEach((ele: any) => {
        tempData.push({
          key: ele?._id,
          value: ele?.value,
        })
      })
      setAllPlatforms(tempData)
    }
  }

  const getContainerListFunction = useCallback(
    async (options: any, columnHeaderValue: any) => {
      setIsLoader(true)
      const selectedParameters = columnHeaderValue.map((column: any) => column.id)

      const payload: any = {
        filters: options.filters,
        sortType: options.sortType ? options.sortType : -1,
        page: options.page ? options.page : 1,
        limit: options.limit ? options.limit : 10,
        selectedParameters,
      }
      if (options.sortBy) {
        payload.sortBy = options.sortBy
      }
      if (options.filterValue) {
        payload.searchText = commaSeparatedArrOfString(options.filterValue)
      }
      if (
        paramState &&
        !options?.filters.some((filter: { filterBy: string }) => filter.filterBy === 'state')
      ) {
        payload.filters = [
          ...options.filters,
          {
            filterBy: 'state',
            filterCondition: 'in',
            filterValue: [paramState],
          },
        ]
      }
      if (
        entryPoint === 'TrayRanking' &&
        !payload.filters.some((filter: { filterBy: string }) => filter.filterBy === 'layout')
      ) {
        payload.filters = [
          ...payload.filters,
          {
            filterBy: 'layout',
            filterCondition: 'in',
            filterValue: ['Master Listing Page'],
          },
        ]
      }
      const requestedData = CONTAINER_MANAGEMENT_CRUD.LISTING(payload)
      const result: any = await mainApiService(requestedData)
      const { responseCode } = handleResponse(result)
      if (responseCode === 200) {
        const record = result?.data?.records
        const extraParameters = [
          'versionCount',
          '_id',
          'isChildPageRequired',
          'isVersionRequired',
          'isCloneRequired',
          containerTrayRankingDefinitionKey,
        ]

        const tempData = await getListingRowData({
          data: record,
          columnHeader: columnHeaderValue,
          extraParams: extraParameters,
          module: entryPoint ?? 'container',
        })
        const enrichedData = tempData.map((row: any) => {
          const apiValue = row.isTrayRankingEnabled
          const isTrayRankingEnabled = apiValue !== 'NA' && apiValue !== false
          const trayRankingDef = row?.[containerTrayRankingDefinitionKey]
          const chipStatus =
            trayRankingDef === false || trayRankingDef === 'NA'
              ? 'unavailable'
              : isTrayRankingEnabled
          return {
            ...row,
            isTrayRankingEnabled: (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <TrayRankingStatusChip status={chipStatus} />
              </div>
            ),
          }
        })
        setDataCount(result?.data?.count)
        setListData(enrichedData)
      } else if (responseCode === 404) {
        setDataCount(0)
        setListData([])
      } else {
        dispatch(showAlert([true, combineErrorMessage(result), 'error']))
      }
      setIsLoader(false)
    },
    [paramState, entryPoint, dispatch],
  )
  useEffect(() => {
    if (stateList?.length === 0) return
    getContainerListFunction(searchFunctionFilters, columnData)
  }, [searchFunctionFilters, stateList, columnData])

  return (
    <>
      <ListingComponent
        isRetainFilters
        columns={columnData}
        tableRows={listData}
        dataCount={dataCount}
        headerBtnLabel={MANAGE_CONTAINER.LISTING.CREATE_BUTTON}
        showCreateButton={entryPoint !== PageNames?.TrayRanking}
        tableTitle={
          entryPoint !== PageNames.TrayRanking
            ? MANAGE_CONTAINER.LISTING.TITLE
            : MANAGE_CONTAINER.LISTING.TRAY_RANKING
        }
        searchPlaceholder={MANAGE_CONTAINER.LISTING.SEARCH_PLACE_HOLDER}
        {...(entryPoint !== PageNames.TrayRanking && {
          cloneProps: {
            isClonable: true,
            cloneSegmemtIdNodeForApiPayload: 'containerId',
            apiMidPoint: 'container',
            redirectViewAPiRouteMidPoint: 'manage-container',
            titleNodeToDisplay: 'containerTitle',
            title: 'Container',
            openInNewTab: true,
          },
        })}
        cloneToDisable='title'
        showAdvanceFilter={true}
        searchFunction={(search, sorttype, coltype, filters, pagenumber, pagecount) => {
          setSearchFunctionFilters((pre) => ({
            ...pre,
            sortBy: coltype,
            filterValue: search,
            sortType: sorttype,
            page: pagenumber,
            limit: pagecount,
            filters,
          }))
        }}
        isLoading={isLoader}
        handleRowClick={(event, isChild) => {
          if (event?.isChildPageRequired?.toLowerCase() === 'yes') {
            isChild &&
              navigate(
                `/${PAGES_ROUTES.ManageContainer}/${PAGES_ROUTES.ChildContainer}/${event._id}`,
              )
          } else {
            isChild &&
              navigate(`/${PAGES_ROUTES.ManageContainer}/${PAGES_ROUTES.PageTypeView}/${event._id}`)
          }
        }}
        paginationOption={CONSTANTS.PAGINATION_OPTIONS}
        showFilterOptions={true}
        headerAddon
        handleClearAllFilters={() => {
          setSearchFunctionFilters((pre) => ({
            ...pre,
            filters: [],
            page: 1,
          }))
          searchParams.delete('state')
          setSearchParams(searchParams)
          setParamState(null)
          dispatch(showAlert([true, 'All filters cleared', 'success']))
        }}
        filterFields={[
          ...(entryPoint !== 'TrayRanking'
            ? [
                {
                  id: 'layout',
                  lable: MANAGE_CONTAINER.LISTING.FILTERS.LAYOUT,
                  searchable: true,
                  clearall: true,
                  options: containerLayoutList,
                },
              ]
            : []),
          {
            id: 'cluster',
            lable: COMMON_LISTING_FILTERS.CLUSTER,
            searchable: true,
            clearall: true,
            options: clusterList,
          },
          {
            id: 'platform',
            lable: COMMON_LISTING_FILTERS.PLATFORM,
            searchable: true,
            clearall: true,
            options: allPlatforms,
          },
          {
            id: 'country',
            lable: COMMON_LISTING_FILTERS.COUNTRY,
            searchable: true,
            clearall: true,
            options: countryList,
          },
          {
            id: 'state',
            lable: MANAGE_CONTAINER.LISTING.FILTERS.STATE,
            searchable: true,
            clearall: true,
            options: stateList,
          },
          {
            id: 'language',
            lable: MANAGE_CONTAINER.LISTING.FILTERS.LANGUAGE,
            searchable: true,
            clearall: true,
            options: languageList,
          },
        ]}
        createButtonClick={() => setOpenDrawer(true)}
        showVersionColumn={entryPoint !== PageNames.TrayRanking}
        isCopyActionAllowed={true}
        copyableColumns={['containerId']}
        entityType='container'
        entryPoint={entryPoint}
      />

      <ContainerRightDrawer
        drawerTitle={'Create Container'}
        onCancel={(data: boolean) => setOpenDrawer(data)}
        open={openDrawer}
      />
    </>
  )
}

export default React.memo(ContainerListing)
